<template>
<div class="mt_140">

    <ccMenu ref="cc_menu"></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
    <div class="row">
    <div class="col-md-12">

          <!-- row -->
          <div class="row">

              <!-- coluna 2 -->
              <div class="col-md-2">
                <ccMenuConta :num=3></ccMenuConta>
              </div">
              <!-- fim coluna 2 -->

              <!-- coluna 10 -->
              <div class="col-md-10 pt-2 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                    <!-- BOTOES -->
                    <section class="mb-5">
                      <div class="row mb-3" style="background-color:#171A28;">
                        <div class="col-6 text_12 text_bold text_cinza">
                          <router-link to="/conta/extrato/torneio" class="btn btn-outline-success w-100 btn-sm mt-3">Extrato dos Torneios</router-link>
                        </div>
                        <div class="col-6 text_12  text-end text_verde">
                          <router-link to="/conta/extrato/transacao" class="btn btn-success w-100 btn-sm mt-3">Extrato das Transações</router-link>
                        </div>
                      </div>
                    </section>

                    <!-- EXTRATO ------------------------------------>
                    <section class="mb-5">
                      <div class="row">
                      <div class="col-md-12">

                          <div class="row mb-2">
                            <div class="col-6">
                              <div class="form-group">
                                <select class="form-control form-control-sm" v-model="frm_acao">
                                  <option value='all'>Todos</option>
                                  <option value='aposta'>Aposta</option>
                                  <option value='deposito'>Preço fixo</option>                
                                </select>
                              </div>
                            </div>

                            <div class="col-6">
                              <div class="form-group">
                                <select class="form-control form-control-sm" v-model="frm_valor_entrada">
                                  <option value="all">Valor de entrada</option>
                                  <option value="r1">0 - 5R$</option>
                                  <option value="r2">R$5 - R$30</option>
                                  <option value="r3">R$30 - R$100 </option>
                                  <option value="r4">R$100 - em diante  </option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="row mb-2">                            
                            <div class="col-4">
                                <div class="form-group mb-2">
                                  <the-mask :mask="['##/##/####']" masked type="text" v-model="dt_inicio"
                                  class="form-control form-control-sm" placeholder="DD/MM/YYYY"
                                  :disabled="disabled_dt_inicio == 1" v-bind:class="[disabled_dt_inicio == 1?'disabled':'']"/>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group mb-2">
                                  <the-mask :mask="['##/##/####']" masked type="text" v-model="dt_fim"
                                  class="form-control form-control-sm" placeholder="DD/MM/YYYY"
                                  :disabled="disabled_dt_fim == 1" v-bind:class="[disabled_dt_fim == 1?'disabled':'']"/>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group mx-sm-1 mb-2">
                                  <button type="button" class="btn btn-secondary w-100 btn-sm" @click="get_extrato()">Filtar</button>
                                </div>
                            </div>
                          </div>

                          <div class="text-center text_laranja mt-4 mb-4" v-show="loading" >
                            <div class="spinner-grow spinner-grow-sm" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                            Carregando
                          </div>

                          <table class="table table-borderles text_branco text_10">
                            <thead>
                              <tr>
                                <th scope="col" width="15%">ID TRANSAÇÃO</th>
                                <th scope="col" width="5%">DATA</th>
                                <th scope="col">TIPO</th>
                                <th scope="col" class="text-center">VALOR</th>
                                <th scope="col" class="text-center">STATUS</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="extrato of extratos" class="text_cinza">
                                <td>{{extrato.id}}</td>
                                <td width="15%">{{extrato.created_at}}</td>
                                <td>{{extrato.acao}}</td>
                                <td width="10%" class="text-center"> <span style="color:#ccc;">{{ extrato.operador }} R$ {{formatarMoeda(extrato.total)}}</span> </td>
                                <td width="8%" class="text-center">{{extrato_status_nome(extrato.status)}}</td>
                              </tr>
                            </tbody>
                          </table>

                          <nav aria-label="Page navigation example">
                            <ul class="pagination">
                              <li class="page-item page-link" @click="set_page('back')" aria-label="Previous" style="cursor: pointer;">
                                  <span aria-hidden="true">&laquo;</span>
                              </li>
                              <li class="page-item page-link" @click="set_page('next')" aria-label="Next" style="cursor: pointer;">
                                  <span aria-hidden="true">&raquo;</span>
                              </li>
                              <li class="page-link">
                                <!-- {{page}} -->
                              </li>
                            </ul>
                          </nav>

                      </div>
                      </div>
                    </section>

              </div>
              <!-- fim coluna 10 -->

          </div>
          <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccContaTopo from '../conta/topo.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'EXTRATOS DA CONTA',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //variaveis
      page: 1,
      frm_acao: 'all',
      frm_valor_entrada: 'all',
      frm_transacao_id: null,
      dt_inicio: null,
      dt_fim: null,
      extratos: [],
    }
  },

  components: {ccMenu, TheMask, ccContaTopo, ccMenuConta, ccLoading, ccFooter},

  created()
  {
    document.title = 'Minha Conta: Extrato Transação - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }else{ this.user = a }

    this.get_extrato()
  },

  methods: {

    get_extrato(){
        this.loading = true;
        var body = {
          page: this.page,
          acao: this.frm_acao,
          valor_entrada: this.frm_valor_entrada,
          transacao_id: this.frm_transacao_id,
          dt_inicio: this.dt_inicio,
          dt_fim: this.dt_fim,
        };

        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.post(this.base_url_api+'conta/extrato/transacao', body, header)
        .then(response => {

          this.page = response.data.page
          this.extratos = response.data.resp

          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
          this.expluse_para_login()
        });
    },

    set_page(p){
        if(p=='back' && this.page > 1){ this.page = this.page - 1 }
        if(p=='next'){ this.page = this.page + 1 }
        this.get_extrato()
    },
  }

}
</script>

<style scoped>
  input.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  input.form-control.disabled{
    background-color: #21232d;
    opacity: 0.5;
  }

  input.form-control::placeholder {
    color: #B7B7B780;
    font-size: 13px;
  }

  select.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  .disabled{
    background-color: #cccccc;
    border: none;
  }

  .page-item{
    border: none;
    background-color: transparent;
    font-size: 20px;
    color: #fff;
  }

  .page-link{
    border: none;
    background-color: transparent;
    color: #fff;
  }

  .table-borderles{
    border: #90919640
  }
</style>



// WEBPACK FOOTER //
// src/components/conta/extrato_transacao.vue